// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { Box, Typography } from '@mui/material';
import FormDialog from '../../../components/Dialog/FormDialog';

interface TerminateDialogProps {
  open: boolean;
  onClose: () => void;
  hasPositions: boolean;
  onTerminate: (() => Promise<unknown>) | undefined;
}
export const AgreementTerminateDialog: React.FC<TerminateDialogProps> = ({
  open,
  onClose,
  onTerminate,
  hasPositions,
}) => {
  const handleSubmit = React.useCallback(() => {
    if (onTerminate) {
      return onTerminate().finally(() => {
        onClose();
      });
    }
    onClose();
    return Promise.resolve();
  }, [onClose, onTerminate]);
  return (
    <FormDialog
      open={open}
      isSubmitDisabled={hasPositions}
      submitButtonSxProps={{ color: 'error' }}
      title={
        <Typography fontWeight="bold" variant="h6" color="error">
          Terminate agreement
        </Typography>
      }
      onCancel={onClose}
      onSubmit={handleSubmit}
      submitName="Terminate"
    >
      {hasPositions ? (
        <Box>
          <Typography variant="body2">
            Agreement cannot be terminated until balance is settled.
          </Typography>
        </Box>
      ) : (
        <Box>
          <Typography variant="body2">
            Termination of the agreement cannot be undone. Once it is terminated, it will no longer
            appear on-ledger.
          </Typography>
          <Typography sx={{ mt: 2 }} variant="body2">
            Would you like to continue?
          </Typography>
        </Box>
      )}
    </FormDialog>
  );
};
